"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var EntityProvider_1 = require("./EntityProvider");
exports.FormComponents = React.createContext({});
exports.FormProvider = function (_a) {
    var form = _a.form, components = _a.components;
    return (React.createElement(react_redux_1.Provider, { store: form },
        React.createElement(exports.FormComponents.Provider, { value: components },
            React.createElement(EntityProvider_1.EntityProvider, { id: "form" }))));
};
//# sourceMappingURL=FormProvider.js.map